
export default {
  name: 'PersonalInvestors',
}
